let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ajhlD")).then(() => parcelRequire('3ANMU'));